(ns app.front.view.group.reporting.list
  (:require [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.ui.table :as ui-table]
            [app.front.view.group.admin.subs :as gas]
            [app.reporting.model :as reporting-model]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::group-reports
  :<- [::gas/group-id]
  (fn [group-id [_ type]]
    @(rf/subscribe [::entities/entities {:domain/authority-group group-id
                                         :entity/type            :entity.type/report
                                         :report/type            type}])))

(rf/reg-sub ::admin-reports
  (fn [_ [_ report-type]]
    @(rf/subscribe [::entities/entities {:entity/type :entity.type/report
                                         :report/type report-type}])))

(rf/reg-sub ::reports
  (fn [[_ report-type]]
    (let [query-id (if (reporting-model/is-admin-report? report-type)
                     ::admin-reports
                     ::group-reports)]
      [(rf/subscribe [query-id report-type])
       (rf/subscribe [:session/user-id])]))
  (fn [[all-reports user-id] _]
    (->> all-reports
         (filter (comp (partial = user-id) :db/id :entity/creator))
         (sort-by :entity/created))))

(rf/reg-sub ::show-section?
  (fn [[_ report-type]]
    (rf/subscribe [::reports report-type]))
  :-> (comp boolean seq))

(defn list-section [{:keys [tr report-type]}]
  (when (<sub [::show-section? report-type])
    [:section
     [:h3 (tr [:reporting/previously-generated-reports])]
     [ui-table/modern-responsive-table
      (util/mmap {:items      (<sub [::reports report-type])
                  :link       {:description (tr [:reporting/download])
                               :make-href   (fn [{report-id :db/id
                                                  state     :domain/state}]
                                              (when (= state :report.state/ready)
                                                (file-download/download-href :report/download-report
                                                                             (util/mmap report-id))))}
                  :get-status (fn [{state :domain/state}]
                                (case state
                                  :report.state/generating :task
                                  :report.state/ready      :ok
                                  nil))
                  :cols       [[:reporting/state
                                (comp #(tr [%]) :domain/state)]
                               [:report/format
                                (comp name :report/format)]
                               [:reporting/created
                                (comp (<sub [::date-util/date-time-fn]) :entity/created)]]}
                 tr)]]))
